import React, { FC } from 'react';
import {
  TypeCtaWithTrailingTextFields,
  TypeMediaAndTextSideBySideFields,
} from '@/core/generated-types';
import Heading, {
  HeadingTag,
  HeadingSize,
} from '@/components/ui/Heading/Heading';
import classNames from 'classnames';
import { getContentType } from '@/core/constants';
import { CTAWithTrailingText, RichText, UniversalCta } from '@/components';
import { Document } from '@contentful/rich-text-types';
import { MediaComponent } from './components/MediaComponent';

export const MediaAndTextSideBySide: FC<TypeMediaAndTextSideBySideFields> = ({
  textHeading,
  textBody,
  mediaLeft,
  image,
  video,
  media,
  entryName,
  cta,
  backgroundColor,
  maxWidth,
  textAlign,
  leadingText,
  centerOnMobile = false,
  videoIsFourThreeAspect,
  containImage,
}) => {
  const textAlignClass = textAlign === 'right' ? 'text-right' : 'text-left';

  const flexAlignClass =
    textAlign === 'right' ? 'justify-end' : 'justify-start';
  return (
    <section
      data-testid={`media-and-text-side-by-side-${entryName}`}
      className={`bg-${backgroundColor?.fields?.color}`}
    >
      <div style={{ maxWidth }} className="mx-auto h-full">
        <div
          className={`flex h-full flex-col md:flex-row ${
            mediaLeft ? '' : 'md:flex-row-reverse'
          }`}
        >
          <div
            className={classNames(
              'relative flex-1 md:w-1/2',
              video || media
                ? ''
                : "before:block before:pt-[100%] before:content-['']",
            )}
          >
            <MediaComponent
              media={media}
              image={image}
              video={video}
              videoIsFourThreeAspect={videoIsFourThreeAspect}
              containImage={containImage}
            />
          </div>
          <div
            className={classNames(
              'box-border flex flex-1 flex-col justify-center px-6 pb-10 pt-8 md:w-1/2 md:max-w-[50%] md:px-16 lg:px-24 ',
              {
                [`text-center md:${textAlignClass}`]: centerOnMobile,
                [textAlignClass]: !centerOnMobile,
              },
            )}
            data-testid="text-container"
          >
            <div>
              {leadingText && (
                <div className="mb-4 text-base text-purple md:text-lg">
                  {leadingText}
                </div>
              )}
              <Heading
                tag={HeadingTag.H2}
                size={HeadingSize.H2}
                text={textHeading}
              />
              <div
                className="mt-3 text-base md:mt-6 md:text-lg"
                data-testid="media-text-body"
              >
                {textBody && <RichText content={textBody as Document} />}
              </div>
              {cta && (
                <div
                  className={classNames('flex pt-6', {
                    [`justify-center md:${flexAlignClass}`]: centerOnMobile,
                    [flexAlignClass]: !centerOnMobile,
                  })}
                >
                  {getContentType(cta) === 'ctaWithTrailingText' ? (
                    <CTAWithTrailingText
                      isCenterAligned={false}
                      {...(cta?.fields as TypeCtaWithTrailingTextFields)}
                    />
                  ) : (
                    <UniversalCta link={cta as any} />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
